'use client';
import React, { useEffect } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import Image from 'next/image';
import Link from 'next/link';

const ContactPage: React.FC = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
    script.type = 'text/javascript';
    script.async = true;
    script.charset = 'utf-8';
    script.onload = () => {
      // @ts-ignore
      if (window.hbspt) {
        // @ts-ignore
        window.hbspt.forms.create({
          portalId: '43968755',
          formId: '3063b08f-c07d-4ae4-aa5e-25bfc026487b',
          target: '#hubspot-form'
        });
      }
    };
    document.body.appendChild(script);
  }, []);

  return (
    <div data-component-id="src/app/contact-us/contactPage.tsx:30:4" data-component-path="src/app/contact-us/contactPage.tsx" data-component-line="30" data-component-end-line="51" data-component-file="contactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20justify-start%20items-center%20w-full%20bg-white%20min-h-screen%22%7D" className="flex flex-col justify-start items-center w-full bg-white min-h-screen">
      <Header data-component-id="src/app/contact-us/contactPage.tsx:31:6" data-component-path="src/app/contact-us/contactPage.tsx" data-component-line="31" data-component-end-line="31" data-component-file="contactPage.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" />

      {/* Center Form Section */}
      <div data-component-id="src/app/contact-us/contactPage.tsx:34:6" data-component-path="src/app/contact-us/contactPage.tsx" data-component-line="34" data-component-end-line="46" data-component-file="contactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-7xl%20px-4%20md%3Apx-8%20py-16%20flex%20justify-center%22%7D" className="w-full max-w-7xl px-4 md:px-8 py-16 flex justify-center">
        <div data-component-id="src/app/contact-us/contactPage.tsx:35:8" data-component-path="src/app/contact-us/contactPage.tsx" data-component-line="35" data-component-end-line="45" data-component-file="contactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B850px%5D%22%7D" className="w-full max-w-[850px]">
          <h1 data-component-id="src/app/contact-us/contactPage.tsx:36:10" data-component-path="src/app/contact-us/contactPage.tsx" data-component-line="36" data-component-end-line="38" data-component-file="contactPage.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22className%22%3A%22text-2xl%20sm%3Atext-3xl%20md%3Atext-4xl%20font-bold%20mb-6%20text-black%20pt-%5B40px%5D%20text-center%22%2C%22textContent%22%3A%22Get%20in%20Touch%22%7D" className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 text-black pt-[40px] text-center">
            Get in Touch
          </h1>

          {/* Form Box */}
          <div data-component-id="src/app/contact-us/contactPage.tsx:41:10" data-component-path="src/app/contact-us/contactPage.tsx" data-component-line="41" data-component-end-line="44" data-component-file="contactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22id%22%3A%22hubspot-form%22%2C%22className%22%3A%22bg-white%20p-5%20sm%3Ap-6%20md%3Ap-8%20border%20border-gray-200%20rounded-%5B20px%5D%20shadow-sm%22%7D"
            id="hubspot-form"
            className="bg-white p-5 sm:p-6 md:p-8 border border-gray-200 rounded-[20px] shadow-sm"
          ></div>
        </div>
      </div>

      <Footer data-component-id="src/app/contact-us/contactPage.tsx:48:6" data-component-path="src/app/contact-us/contactPage.tsx" data-component-line="48" data-component-end-line="48" data-component-file="contactPage.tsx" data-component-name="Footer" data-component-content="%7B%22elementName%22%3A%22Footer%22%7D" />

      
    </div>
  );
};

export default ContactPage;
